module.exports = __webpack_public_path__ + "img/unstarted.fe2cd4f1.svg";